import { BakeryModule } from 'modules';

export const BakeryScreen = () => {
  return <BakeryModule />;
};
